export default __webpack_public_path__ + "static/media/bicycle-offline.617494c2.png";